import React, { useRef, useEffect, forwardRef } from "react";
import { useGLTF, PerspectiveCamera, useAnimations, useProgress } from "@react-three/drei";

import { state } from './store/index.js';
import { useConfigurator } from "./context/context.jsx";
import { useImperativeHandle } from "react";

const Model = forwardRef(function (props, modelRef) {

  const group = useRef();
  const boxRef = useRef()

  const { nodes, materials, animations } = useGLTF("./scene.glb");
  const { actions, mixer } = useAnimations(animations, group)

  const {
    setActions, setMixer, setAnimations, setClickedMesh,setMaterials
  } = useConfigurator()

  const { onHover, onHoverOut } = props.passedFunctions;

  useImperativeHandle(modelRef,
    function () {
      return {
        group, boxRef
      }
    }, [])

  useEffect(() => {
    group.current.visible = false
    console.log(actions)
    setActions(actions)
    setMixer(mixer)
    setAnimations(animations)
    setMaterials(materials)
    state.modelReady = true
  }, [actions])

  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Scene">
        <PerspectiveCamera
          name="camera"
          makeDefault={true}
          far={10000}
          near={0.1}
          fov={37.849}
          position={[0.145, 0.21, -0.205]}
          rotation={[-2.329, 0.452, 2.71]}
        />
        
        <directionalLight
          name="light_bottom_left"
          intensity={0}
          decay={2}
          color="#ffffff"
          position={[0.144, 0.21, -0.205]}
          rotation={[-2.83, 0.876, -2.049]}
        >
          <group position={[0, 0, -1]} />
        </directionalLight>
        <directionalLight
          name="light_top_back"
          intensity={1}
          decay={2}
          color="#ffffff"
          position={[-0.061, 0.874, 1.625]}
          rotation={[-0.301, -0.012, -1.378]}
        >
          <group position={[0, 0, -1]} />
        </directionalLight>
        <pointLight
          name="Point"
          intensity={0}
          decay={2}
          color="#ffffff"
          position={[-0.722, 0.505, 0.54]}
          rotation={[-Math.PI / 2, 0, 0]}
        />
        <mesh
          name="Sleeve"
          castShadow
          receiveShadow
          geometry={nodes.Sleeve.geometry}
          material={materials["Cioccolatini_MT.002"]}
        />
   <group ref={boxRef} onPointerUp={(e) => { setClickedMesh(e) }} onPointerOver={e => { onHover(e) }} onPointerOut={e => { onHoverOut() }} name="Cioccolatini_Stud_GRP">
          <mesh
            name="Choco_1"
            castShadow
            receiveShadow
            geometry={nodes.Choco_1.geometry}
            material={materials["Cioccolatini_MT.002"]}
          />
          <mesh
            name="Choco_2"
            castShadow
            receiveShadow
            geometry={nodes.Choco_2.geometry}
            material={materials["Cioccolatini_MT.002"]}
          />
          <mesh
            name="Choco_3"
            castShadow
            receiveShadow
            geometry={nodes.Choco_3.geometry}
            material={materials["Cioccolatini_MT.002"]}
          />
          <mesh
            name="Choco_4"
            castShadow
            receiveShadow
            geometry={nodes.Choco_4.geometry}
            material={materials["Cioccolatini_MT.002"]}
          />
          <mesh
            name="Choco_5"
            castShadow
            receiveShadow
            geometry={nodes.Choco_5.geometry}
            material={materials["Cioccolatini_MT.002"]}
          />
          <mesh
            name="Choco_6"
            castShadow
            receiveShadow
            geometry={nodes.Choco_6.geometry}
            material={materials["Cioccolatini_MT.002"]}
          />
          <mesh
            name="Choco_7"
            castShadow
            receiveShadow
            geometry={nodes.Choco_7.geometry}
            material={materials["Cioccolatini_MT.002"]}
          />
          <mesh
            name="Choco_8"
            castShadow
            receiveShadow
            geometry={nodes.Choco_8.geometry}
            material={materials["Cioccolatini_MT.002"]}
          />
          <mesh
            name="Choco_9"
            castShadow
            receiveShadow
            geometry={nodes.Choco_9.geometry}
            material={materials["Cioccolatini_MT.002"]}
          />
        </group>
        <group name="Scatola_Sotto">
          <mesh
            name="extracted_01"
            castShadow
            receiveShadow
            geometry={nodes.extracted_01.geometry}
            material={materials["Cioccolatini_MT.002"]}
          />
          <mesh
            name="pCube1"
            castShadow
            receiveShadow
            geometry={nodes.pCube1.geometry}
            material={materials["Cioccolatini_MT.002"]}
            position={[0, 0.004, 0]}
          />
          <mesh
            name="pCube2"
            castShadow
            receiveShadow
            geometry={nodes.pCube2.geometry}
            material={materials["Cioccolatini_MT.002"]}
            position={[0, 0.004, 0]}
          />
        </group>
        <mesh
          name="Piano_Fondo"
          castShadow
          receiveShadow
          geometry={nodes.Piano_Fondo.geometry}
          material={materials["lambert1.002"]}
        />
      </group>
    </group>
  );
}

  

)



export { Model }